<template>
  <div data-component="v layout">
    <c-navigation />
    <div class="">
      <router-view class="" />
    </div>
  </div>
</template>

<script>
import CNavigation from '../../components/Navigation/Index';
import CFooter from '../../components/Footer/Index';

export default {
  name: 'VLayout',
  components: {
    CNavigation,
  },
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style>
@font-face {
  font-family: "DIN Pro";
  src: url('../../../src/assets/fonts/FFDINWebProRegular/font.woff');
}
@font-face {
  font-family: "DIN Pro Bold";
  src: url('../../../src/assets/fonts/FFDINWebProBold/font.woff');
}
@font-face {
  font-family: "DIN Pro Medium";
  src: url('../../../src/assets/fonts/FFDINWebProMedium/font.woff');
}
*{
  font-family: 'DIN Pro';
}
</style>
